import { Component } from '@angular/core';

@Component({
  selector: 'app-semirremolque-no-selected',
  templateUrl: './semirremolque-no-selected.component.html',
  styleUrls: ['./semirremolque-no-selected.component.css'],
})
export class SemirremolqueNoSelectedComponent {}
